import { useState } from 'react'
import useRequestPending from 'shared/hooks/useRequestPending'
import { createVehicle } from 'dashboard-vehicles/actions'
import { CURRENT_COUNTRY_CANADA } from 'shared/constants'
import useCountryState from 'shared/hooks/useCountryState'
import { createVehiclePendingSelector } from 'dashboard-vehicles/selectors'
import { businessAccountSelector } from 'auth/selectors'

import VehicleFormComponent from '@components/VehicleForm'
import InfoModal from '@components/InfoModal'

const INITIAL_STATE = {
    tag: '', // '1337',
    make: '', // 'Maserati',
    model: '', // 'Quattroporte',
    color: '', // 'Black'
}

const VehicleForm = ({ createVehicle, pending, translate: t, onSuccess, isBusinessAccount }) => {
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
    const [formValues, setFormValues] = useState(INITIAL_STATE)
    const { countryStateComponent, selectedCountry, selectedState, setSelectedCountry, setSelectedState } =
        useCountryState()
    const { error, isLoading } = useRequestPending(pending, () => {
        setIsInfoModalOpen(true)
    })

    const submitVehicle = async () => {
        const { tag, make, model, color } = formValues
        createVehicle(tag, make, model, color, selectedCountry, selectedState)
        setFormValues(INITIAL_STATE)
        setSelectedCountry(CURRENT_COUNTRY_CANADA)
        setSelectedState(null)
    }

    return (
        <>
            {isInfoModalOpen && isBusinessAccount && (
                <InfoModal
                    title="dashboard.vehicles.warning.title"
                    text="dashboard.vehicles.warning.text"
                    onDismiss={() => {
                        if (onSuccess) {
                            onSuccess()
                        }
                        setIsInfoModalOpen(false)
                    }}
                />
            )}
            <VehicleFormComponent
                submitVehicle={submitVehicle}
                setFormValues={setFormValues}
                formValues={formValues}
                isLoading={isLoading}
                error={error}
                countryStateComponent={countryStateComponent}
                isSubmitButtonDisplayed
            />
        </>
    )
}

const mapDispatchToProps = {
    createVehicle,
}

const mapStateToProps = createStructuredSelector({
    pending: createVehiclePendingSelector,
    isBusinessAccount: businessAccountSelector,
})

export default compose(withTranslate, connect(mapStateToProps, mapDispatchToProps))(VehicleForm)
